import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom"; // Для работы с URL
import axios from "axios";
// import { ReactComponent as Union } from "../../union.svg";

import Payment from "../payment/payment";
import {
  actions,
  getIsInvalidatedData,
  getPaymentDetails,
} from "../redux/main-reducer";

import "../paymentInfo/paymentInfo.css";
import { attachImageUrl } from "../../utils/attachImageUrl";
import errorImg from "../../images/error-warning-fill.svg";
import arrow from "../../images/arrow.svg";
import PhoneNumberPayment from "../phoneNumberPayment/phoneNumberPayment";
import SavedCards from "../savedCards/SavedCards";

function PaymentMerchantInfo() {
  const isInvalidated = useSelector(getIsInvalidatedData);
  const paymentDetails = useSelector(getPaymentDetails);
  const location = useLocation();
  const API_ROOT = process.env.REACT_APP_API_ROOT;
  // const API_ROOT = "https://acqt.hamkorbank.uz";
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [value, setValue] = React.useState("card");
  const [isOpen, setIsOpen] = useState(false);
  const [isShowForm, setIsShowForm] = useState(false);
  const [commonErrorMessage, setCommonErrorMessage] = useState("");

  // Состояния для сохраненных карт
  const [showAllCards, setShowAllCards] = useState(false);
  const [showAddCardForm, setShowAddCardForm] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);

  const dispatch = useDispatch();

  console.log(selectedCard)

  // Обработчики для сохраненных карт
  const handleCardSelect = (card) => {
    setSelectedCard(card);
  };

  useEffect(() => {
    const fetchPaymentDetails = async () => {
      try {
        setLoading(true);

        const params = new URLSearchParams(location.search);
        const key = params.get("key");

        if (!key) {
          throw new Error("Параметр 'key' отсутствует в URL");
        }

        const response = await axios.get(
          `${API_ROOT}/api/v1/ecomm/payments/invoice/${key}`
        );

        if (response.data) {
          dispatch(actions.setPaymentDetails(attachImageUrl(response?.data?.data)));
          dispatch(actions.setInvaliidateData(false));
          console.log(response?.data?.data);
        } else {
        }
      } catch (err) {
        if (err?.response?.data?.error_note == "url is expired") {
          setError("Cрок действия URL-адреса истек");
        } else if (err?.response?.data?.error_code == -30) {
          setError("Срок действия платежа истёк");
        } else {
          setError(err.message);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchPaymentDetails();
  }, [location.search, isInvalidated]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  if (loading) {
    return (
      <div className="paymentInfo">
        {/* <div className="paymentInfo-logo">
          <img src={paymentDetails?.image_url || ""} alt="logo" />
        </div> */}
        <div className="paymentInfo-loading">
          <div className="spinner"></div>
          <p>Загрузка данных...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="paymentInfo">
        {/* <div className="paymentInfo-logo">
          <img src={paymentDetails?.image_url || ""} alt="logo" />
        </div> */}
        <div className="paymentInfo-error">
          <p style={{ color: "red" }}>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="paymentInfo">
      <div className="paymentInfo-container">
        {commonErrorMessage && (
          <div className="paymentInfo-common-error">
            <img className="paymentInfo-error__image" src={errorImg} alt="" />
            <div className="paymentInfo-error__title">{commonErrorMessage}</div>
          </div>
        )}
        <div
          onClick={() => setIsOpen(!isOpen)}
          className={`paymentInfo-details-list ${isOpen && `_border-radius`}`}
        >
          <img
            className="paymentInfo-details-list-left-block__logo"
            src={paymentDetails?.image_url || ""}
            alt="logo"
          />
          <div className="paymentInfo-details-list-content">
            <div className="paymentInfo-details-list-left-block">
              <div className="paymentInfo-details-list-left-block__name">
                {paymentDetails?.merchant_org_name}
              </div>
              <div className="paymentInfo-details-list-left-block__amount">
                {paymentDetails?.total_amount &&
                paymentDetails?.total_amount !== 0
                  ? paymentDetails?.total_amount
                  : paymentDetails?.amount}{" "}
                сум
              </div>
            </div>
            <img
              className={`paymentInfo-details-list-right-block__image ${
                isOpen && `_rotated-image`
              }`}
              src={arrow}
              alt="arrow-button"
            />
          </div>
        </div>
        {isOpen && (
          <div className="paymentInfo-details">
            <div className="paymentInfo-detail">
              Номер счета <span>{paymentDetails?.invoice_id}</span>
            </div>
            <div className="paymentInfo-detail">
              Организация <span>{paymentDetails?.merchant_org_name}</span>
            </div>
            <div className="paymentInfo-detail">
              Название <span>{paymentDetails?.product_name}</span>
            </div>
            <div className="paymentInfo-detail">
              Сумма <span>{paymentDetails?.amount} сум</span>
            </div>
            {paymentDetails?.phone_number && (
              <div className="paymentInfo-detail">
                Телефон <span>{paymentDetails.phone_number}</span>
              </div>
            )}
            {paymentDetails?.email && (
              <div className="paymentInfo-detail">
                Email <span>{paymentDetails.email}</span>
              </div>
            )}
            {paymentDetails?.order_number && (
              <div className="paymentInfo-detail">
                Номер заказа <span>{paymentDetails.order_number}</span>
              </div>
            )}
            {paymentDetails?.commission && (
              <div className="paymentInfo-detail">
                Комиссия <span>{paymentDetails.commission}</span>
              </div>
            )}
            {paymentDetails?.total_amount && (
              <div className="paymentInfo-detail">
                Общая сумма <span>{paymentDetails.total_amount}</span>
              </div>
            )}
          </div>
        )}
        <div className="paymentInfo-card-container">
          <div className="paymentInfo-card__name">
            {isShowForm ? "Введите код из СМС" : "Быстрая оплата"}
          </div>
          {/* Компонент сохраненных карт */}
          {paymentDetails?.show_save_card && (
              <SavedCards
                savedCards={paymentDetails?.saved_cards}
                showAllCards={showAllCards}
                setShowAllCards={setShowAllCards}
                showAddCardForm={showAddCardForm}
                setShowAddCardForm={setShowAddCardForm}
                onCardSelect={handleCardSelect}
                setCommonErrorMessage={setCommonErrorMessage}
                selectedCard={selectedCard}
                onShowForm={setIsShowForm}
                isShowForm={isShowForm}
              />
          )}
          {/* {!isShowForm && (
            <>
              <button
                onClick={() => setValue(value === "card" ? "phone" : "card")}
                type="button"
                className="paymentInfo-card__phone"
              >
                {value === "card"
                  ? "Оплатить по номеру телефона"
                  : "Оплатить с помощью карты"}
              </button>
              <div class="divider">
                <span>
                  {value === "card"
                    ? "Или оплатите картой"
                    : "Или оплатите по номеру телефона"}
                </span>
              </div>
            </>
          )} */}
          {/* {paymentDetails?.is_finished && <PaymentCheque />} */}
          {value === "card" ? (
            <Payment
              isShowForm={isShowForm}
              onShowForm={setIsShowForm}
              setCommonErrorMessage={setCommonErrorMessage}
            />
          ) : (
            <PhoneNumberPayment
              isShowForm={isShowForm}
              onShowForm={setIsShowForm}
              setCommonErrorMessage={setCommonErrorMessage}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default PaymentMerchantInfo;
